import { render } from "./SubLink.vue?vue&type=template&id=83fb917c&scoped=true"
import script from "./SubLink.vue?vue&type=script&lang=js"
export * from "./SubLink.vue?vue&type=script&lang=js"

import "./SubLink.vue?vue&type=style&index=0&id=83fb917c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83fb917c"]])

export default __exports__